export default "__VITE_PUBLIC_ASSET__8659133a__"